import { State } from "../state/state";
import { Utils } from "../../../utils";

// Convert server data to User Interface friendly data
export const fromServer = (data: State.DataServer): State.Data => {
  return {
    ...data,
    policies: Utils.bitmapToArray(data.policies, 3)
  };
};

// Convert User Interface friendly data to server data
export const toServer = (data: State.Data): State.DataServer => {
  return {
    ...data,
    policies: Utils.arrayToBitmap(data.policies)
  };
};
